module.exports = __webpack_public_path__ + "static/media/premium.90f926e1.svg";